window.isBantoaLoaded = false;

// qui attacchiamo il tracker di Bantoa che serve purtroppo per tutto il resto
class Bantoa {
  static EVENTS = {
    LOADED: "bantoa_loaded",
  }

  init = () => {
    const self = this;
    !function(t,n,e,a,c,o,r,s){t.BantoaTrackerObject=c,t[c]=t[c]||function(){(t[c].q=t[c].q||[]).push(arguments)},
    t[o]=t[o]||function(){(t[o].q=t[o].q||[]).push(arguments)},
    r=n.createElement(e),s=n.getElementsByTagName(e)[0],r.async=1, r.onload=self.started, r.src=a,s.parentNode.insertBefore(r,s)}
    (window,document,"script","https://www.bantoa.com/bantoa.tk.min.js?apikey=NTE4X2JhbnRvYWtleQ==","bnt_t","bnt_r_ai");
  }

  started = () => {
    window.isBantoaLoaded = true;
    ShopifyTheme.customEvent(Bantoa.EVENTS.LOADED);
    console.log("Bantoa tracker initialized");
  }
}

// questo gestisce il visual search, in pratica al click sul componente ti fa caricare immagine e poi fa partire il visual search con l'immagine caricata (base64)
class BantoaSearch extends HTMLElement {

  connectedCallback() {
    if(!this.dataset.position){
      console.error("BantoaSearch: No position found in the element.");
      return;
    }
    this.addEventListener('click', this.openViewer.bind(this));
    const url = new URL(window.location.href);
    if(url.searchParams.has("bantoa")){
      this.openViewer(this);
    }
  }

  addParameterToUrl(){
    const url = new URL(window.location.href);
    url.searchParams.append("bantoa", "bantoa");
    window.history.pushState({}, '', url)
  }

  openViewer = (base64Img) => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaSearch: Bantoa tracker is not loaded.");
      window.addEventListener(Bantoa.EVENTS.LOADED, () => this.openViewer(base64Img));
      return;
    }
    bnt_r_ai('visual', 'modal', {
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
	  });
    const url = new URL(window.location.href);
    if(!url.searchParams.has("bantoa")){
      this.addParameterToUrl();
    }
  }
}
customElements.define("bantoa-search", BantoaSearch);

// questo al click apre il cosetto di bantoa per trovare prodotti simili
class BantoaProductSearch extends HTMLElement {

  connectedCallback() {
    console.log("BantoaProductSearch: Connected", this.id);
    if(!this.dataset.sku) {
      console.error("BantoaProductSearch: No SKU found in the element.");
      return;
    }
    if(!this.dataset.position){
      console.error("BantoaSearch: No position found in the element.");
      return;
    }
    if(window.isBantoaLoaded)
      this.init();
    window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
    this.checkExists();
  }

  checkExists = () => {
    axios({
      url: `https://api.bantoa.com/api/visual?apikey=NTE4X2JhbnRvYWtleQ==&onlycheckexist=1&code=${this.dataset.sku}&tm=1751548151`,
      method: 'get',
    }).then(r => {
      if(r.data.productexist == 'ok'){
        this.classList.remove('d-none');
      }
    })
    .catch(e => {
      console.error("BantoaProductSearch: Error checking product existence", e);
    });
  }

  init = () => {
    this.addEventListener('click', this.openViewer.bind(this));
  }

  openViewer = () => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaSearch: Bantoa tracker is not loaded.");
      return;
    }
    const data = {
	    item: this.dataset.sku,
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
    };
    if(this.dataset.variant){
      data.filter = {
        sizes: this.dataset.variant
      };
    }
    bnt_r_ai('visual', 'modal', data);
  }
}
customElements.define("bantoa-product-search", BantoaProductSearch);

class BantoaCarousel extends CustomCarousel {
  bantoaProducts;

  connectedCallback() {
    console.log("BantoaCarousel: Connected");
    if(!this.dataset.position){
      console.error("BantoaCarousel: No position found in the element.");
      return;
    }
    if(!this.dataset.product){
      console.error("BantoaCarousel: No product found in the element.");
      return;
    }
    window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
    if(window.isBantoaLoaded)
      this.init();
  }

  init = () => {
    console.log("BantoaCarousel: Initialized");
    if(!window.isBantoaLoaded) {
      console.error("BantoaCarousel: Bantoa tracker is not loaded.");
      return;
    }
    bnt_r_ai('visual', 'data', {
      max_results: 10,
      position: this.dataset.position,
      item: this.dataset.product,
    }).then(data => {
      this.bantoaProducts = data.data?.products || [];
      console.log("BantoaCarousel: Products fetched", this.bantoaProducts);
      this.start();
    }).catch(err => {
      console.error('Visual-data promise failed:', err);
    });
  }

  start = () => {
    const skus = this.bantoaProducts.map(product => product.sku);
    this.getProducts(skus);
  }

  getTrackingProduct = (product) => {
    const p = this.bantoaProducts.find((prod) => prod.sku == product.metaGroupCode.value);
    product.trackingUrl = p?.trackingurl;
    product.sku = p?.sku || product.sku;
    return product;
  }
}
customElements.define("bantoa-carousel", BantoaCarousel);